import React from "react";

const ExternalCheckoutLink = () => {
  return (
    <a
      href="https://opensea.io/collection/lp-runaway"
      style={{ color: "black" }}
    >
      <i className="ri-external-link-line"></i>
    </a>
  );
};

export default ExternalCheckoutLink;
